import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const WarningCard = (props) => {
  const {
    title,
    reading,
    product,
    productId,
    fuel,
    fuelMin,
    coolant,
    coolantMax,
  } = props;
  const {
    powerFactor,
    frequency,
    powerFactorOffset,
    powerKW,
    powerKWOffset,
    voltage,
    voltageOffset,
    batteryVoltage,
    batteryVoltageOffset,
    frequencyOffset,
    current,
    currentOffset,
    isConnected
  } = product;
  
  const { vY, vR, vB } = voltage[voltage.length - 1];
  const { iY, iR, iB } = current[current.length - 1];
  const cardColorchange = () => {
    if (!isConnected) {
      return false;
    }
    if (
      iY > currentOffset.max ||
      iR > currentOffset.max ||
      iB > currentOffset.max
    ) {
      return true
    }
    
    if (powerKW[powerKW.length - 1] > powerKWOffset.max) {
      return true
    }

    if (
      vY > voltageOffset.max ||
      vR > voltageOffset.max ||
      vB > voltageOffset.max
    ) {
      return true
    }

    if (frequency[frequency.length - 1] > frequencyOffset.max) {
      return true
    }
    if (powerFactor[powerFactor.length - 1] < powerFactorOffset.min) {
      return true
    }

    if (batteryVoltage[batteryVoltage.length - 1] < batteryVoltageOffset.min) {
      return true
    }

    if (frequency[frequency.length - 1] < frequencyOffset.min) {
      return true
    }

    if (
      vY < voltageOffset.min ||
      vR < voltageOffset.min ||
      vB < voltageOffset.min
    ) {
      return true
    }
    return false;
  };

  return (
    productId && (
      <Link
        to={`/product/${productId}`}
        className="tw-text-black tw-font-normal sm:tw-w-1/6 tw-w-4/5"
        style={{ textDecoration: "none" }}
      >
        <div
          className={`tw-font-nunito tw-text-center tw-py-3 tw-m-2 
      tw-rounded-md tw-shadow-md`}
            style={{backgroundColor: cardColorchange() ? "#f4b4b1" : "#f3f4f6"}}
        >
          <Row className="tw-flex tw-justify-evenly tw-items-center tw-my-3 tw-px-3">
            <Col xs={7} className="sm:tw-text-2xl tw-text-3xl tw-font-bold">
              {title}
            </Col>
            <Col xs={5}>
              {isConnected && <i className={`fas fa-bolt fa-lg`}></i>}
            </Col>
          </Row>
          <Row className="tw-flex tw-justify-evenly tw-items-center tw-my-3">
            <Col xs={6} className={`tw-w-8 tw-h-8`}>
              <i
                className="fas fa-thermometer-half fa-lg"
                style={{ color: (coolant > coolantMax) ? "red" : "green" }}
              ></i>
            </Col>
            <Col
              xs={6}
              className={`tw-animate-pulse tw-rounded-full tw-w-8 tw-h-8 ${
                reading === "ON" ? "tw-bg-green-500" : "tw-bg-red-500"
              }`}
            ></Col>
            <Col xs={6} className={`tw-w-8 tw-h-8`}>
              <i
                className={`fas fa-gas-pump fa-lg`}
                style={{ color: (fuel < fuelMin) ? "red" : "green" }}
              ></i>
            </Col>
            <div className="tw-mt-5 tw-font-bold">
              {reading === "ON" ? "ON" : "OFF"}
            </div>
          </Row>
          {/* {status && (
            <p
              className={`sm:tw-text-3xl tw-text-2xl tw-font-extrabold tw-pt-3 tw-mb-0 ${
                status === "ON" ? "tw-text-green-600" : "tw-text-red-600"
              }`}
            >
              {status === "ON" ? "ON" : "OFF"}
            </p>
          )} */}
        </div>
      </Link>
    )
  );
};

export default WarningCard;
